import React from "react";
import "../styles/about.scss";
import aboutImg from "../images/about.webp";

export default function AboutUs() {
  return (
    <section className="main-container about-us-section">
      <div className="about-us-container">
        <div className="about-us-image">
          <img src={aboutImg} alt="Ko smo mi?" />
        </div>

        <div className="about-us-content">
          <h2 className="title">Ko smo mi?</h2>
          <p className="about-us-description">
            Unijana je kompanija sa dugogodišnjim iskustvom u kreiranju i
            isporuci visokokvalitetnih uniformi za različite industrije.
            Posvećeni smo tome da spojimo funkcionalnost, udobnost i estetiku,
            pružajući rešenja koja odražavaju profesionalnost i identitet vašeg
            tima. Naš tim stručnjaka pažljivo osluškuje potrebe klijenata, kako
            bismo isporučili proizvode koji prevazilaze očekivanja.
          </p>
          <p className="about-us-highlight">
            Izgradimo zajedno uniformu koja govori o vašem brendu!
          </p>

          <a href="/o-nama" className="btn-primary">
            Saznajte više
          </a>
        </div>
      </div>
    </section>
  );
}
